import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Just } from "@discovery/prelude/lib/data/maybe";
/**
 * Getters
 */
export const _CollectionGetter = Getter.of();
export const _CollectionResponseGetter = Getter.of();
export const _CollectionItemGetter = Getter.of();
export const _ColItem2Data = Fold.compose(_CollectionItemGetter, Res._Response());
export const _Col2Data = Fold.compose(_CollectionGetter, Res._Response());
export const _Col2Attributes = Fold.compose(_Col2Data, Lens.prop("attributes"));
export const _ColItem2Attributes = Fold.compose(_ColItem2Data, Lens.prop("attributes"), _Just());
export const _ColAttributes2Alias = Fold.compose(_Col2Attributes, Lens.prop("alias"));
export const _ColAttributes2Component = Fold.compose(_Col2Attributes, Lens.prop("component"));
export const _ColAttributes2Async = Fold.compose(_Col2Attributes, Lens.prop("async"));
export const _ColAttributes2Description = Fold.compose(_Col2Attributes, Lens.prop("description"));
export const _ColAttributes2Hints = Fold.compose(_Col2Attributes, Lens.prop("hints"));
export const _ColAttributes2Name = Fold.compose(_Col2Attributes, Lens.prop("name"));
export const _ColAttributes2PageMetadataDescription = Fold.compose(_Col2Attributes, Lens.prop("pageMetadataDescription"));
export const _ColAttributes2Published = Fold.compose(_Col2Attributes, Lens.prop("published"));
export const _ColAttributes2State = Fold.compose(_Col2Attributes, Lens.prop("state"));
export const _ColAttributes2Title = Fold.compose(_Col2Attributes, Lens.prop("title"));
export const _Col2Items = Fold.compose(_CollectionGetter, Res._Rel("items"), Res._ForEach());
export const _ColItemAttributes2CallToAction = Fold.compose(_ColItem2Attributes, Lens.prop("callToAction"));
export const _ColItemAttributes2Description = Fold.compose(_ColItem2Attributes, Lens.prop("description"));
export const _ColItemAttributes2Hidden = Fold.compose(_ColItem2Attributes, Lens.prop("hidden"));
export const _ColItemAttributes2Hints = Fold.compose(_ColItem2Attributes, Lens.prop("hints"));
export const _ColItemAttributes2PublishEnd = Fold.compose(_ColItem2Attributes, Lens.prop("publishEnd"));
export const _ColItemAttributes2PublishStart = Fold.compose(_ColItem2Attributes, Lens.prop("publishStart"));
export const _ColItemAttributes2RecurringSchedule = Fold.compose(_ColItem2Attributes, Lens.prop("recurringSchedule"));
export const _ColItemAttributes2Title = Fold.compose(_ColItem2Attributes, Lens.prop("title"));
export const _ColItemAttributes2SecondaryTitle = Fold.compose(_ColItem2Attributes, Lens.prop("secondaryTitle"));
export const _ColItem2Article = Fold.compose(_CollectionItemGetter, Res._Rel("article"));
export const _ColItem2Channel = Fold.compose(_CollectionItemGetter, Res._Rel("channel"));
export const _ColItem2Collection = Fold.compose(_CollectionItemGetter, Res._Rel("collection"));
export const _ColItem2Image = Fold.compose(_CollectionItemGetter, Res._Rel("image"));
export const _ColItem2Images = Fold.compose(_CollectionItemGetter, Res._Rel("images"), Res._ForEach());
export const _ColItem2Link = Fold.compose(_CollectionItemGetter, Res._Rel("link"));
export const _ColItem2Show = Fold.compose(_CollectionItemGetter, Res._Rel("show"));
export const _ColItem2TaxonomyNode = Fold.compose(_CollectionItemGetter, Res._Rel("taxonomyNode"));
export const _ColItem2Video = Fold.compose(_CollectionItemGetter, Res._Rel("video"));

